import { store } from "../state/store.js";
import { FREE_TO_AIR_DE, SKY_DE, HDPLUS, TELEVES_K20_16 } from "../constants/favorites.js";
import { tpKey } from "./tpKey.js";
import { norm } from "../utils/text.js";
import { srEq, freqEq } from "../utils/num.js";

export function matchBy4Fields(t,fav){
  return String(t.sat_pos)===String(fav.sat_pos)
    && freqEq(t.frequency_MHz,fav.frequency_MHz)
    && norm(t.pol)===norm(fav.pol)
    && srEq(t.symbolrate_kSps,fav.symbolrate_kSps);
}

export function keysFromFavList(list){
  const keys=[];

  for(const fav of list){
    const candidates=store.transponders
      .filter(t =>
        String(t.sat_pos)===String(fav.sat_pos)
        && norm(t.pol)===norm(fav.pol)
        && freqEq(t.frequency_MHz,fav.frequency_MHz)
        && srEq(t.symbolrate_kSps,fav.symbolrate_kSps)
      )
      .sort((a,b) => {
        const freqDeltaA=Math.abs(Number(a.frequency_MHz)-Number(fav.frequency_MHz));
        const freqDeltaB=Math.abs(Number(b.frequency_MHz)-Number(fav.frequency_MHz));
        if(freqDeltaA!==freqDeltaB) return freqDeltaA-freqDeltaB;

        const srDeltaA=Math.abs(Number(a.symbolrate_kSps)-Number(fav.symbolrate_kSps));
        const srDeltaB=Math.abs(Number(b.symbolrate_kSps)-Number(fav.symbolrate_kSps));
        return srDeltaA-srDeltaB;
      });

    const hit=candidates[0];
    if(hit) keys.push(tpKey(hit));
  }

  return keys;
}

export function ownFavKeys(){ return [...store.starred].filter(k=>store.tpByKey.has(k)); }
function allSelected(keys){ return keys.length>0 && keys.every(k=>store.selection.has(k)); }
export function toggleGroup(keys){
  const remove=allSelected(keys);
  for(const k of keys){ if(remove) store.selection.delete(k); else store.selection.set(k,true); }
}
export const favLists={ FREE_TO_AIR_DE, SKY_DE, HDPLUS, TELEVES_K20_16 };